import { FC } from 'react';

import { TOTAL_QUIZ_STEPS } from 'components/FreeTrialFTUX/hooks/useFreeTrialStore';

interface ProgressBarProps {
  currentStepNumber: number;
}

const ProgressBar: FC<ProgressBarProps> = ({ currentStepNumber }) => {
  const fillRatio = Math.min(currentStepNumber / TOTAL_QUIZ_STEPS, 1);

  return (
    <div className="flex flex-col gap-4">
      <span className="text-xs leading-6 text-gray-1000">
        {currentStepNumber} of {TOTAL_QUIZ_STEPS}
      </span>
      <div className="relative h-[3px] w-full bg-gray-300">
        <div
          className="absolute inset-y-0 left-0 bg-primary-300 transition-all duration-300"
          style={{ width: `${fillRatio * 100}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
